import { render, staticRenderFns } from "./ChemCPP1210LPrelabEquations1.vue?vue&type=template&id=4b5b24b9&scoped=true&"
import script from "./ChemCPP1210LPrelabEquations1.vue?vue&type=script&lang=js&"
export * from "./ChemCPP1210LPrelabEquations1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b24b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
